module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921024149_T.89888d1d.jpg";